import { EcommerceProductModel } from '@/helpers/entities/models/EcommerceProductModel';
import { omit } from 'lodash';
export class EcommerceProductPromoModel {
    constructor(payload) {
        Object.assign(this, omit(payload, 'promoProducts'));
        const productNode = (product) => {
            return new EcommerceProductModel(product.node.product);
        };
        this.promoProducts = payload.promoProducts.edges.map(productNode);
    }
}
